module.exports = __webpack_public_path__ + "static/media/review_1.eb62a9c6.jpg";